import React, { useContext } from "react";
import { Container, Col, Image, Row } from "react-bootstrap";
import logoImage from "../assets/img/logo.png";
import { NavLink } from "react-router-dom";
import { IPUrl } from "../commons/IPAddress";
import MunicipalityDataContext from "../helpers/MunicipalityDataContext";

function HeaderLogin() {
  const municipalitiyData = useContext(MunicipalityDataContext);

  return (
    <div>
      <header>
        <Container fluid className="rgc-header">
          <Row className="justify-content-center">
            <Col className="text-center">
              <NavLink to="/">
                <div className="rgc-logo d-flex justify-content-center">
                  <Image src={`${IPUrl}UploadedFile/Logo/Logo.png`} />
                  <div className="rgc-logo-part  d-flex flex-column">
                    <span>سامانه {municipalitiyData?.name} من</span>
                    <span>
                      خدمات آنلاین شهرداری
                      {municipalitiyData?.name}
                    </span>
                  </div>
                </div>
              </NavLink>
            </Col>
          </Row>
        </Container>
      </header>
    </div>
  );
}

export default HeaderLogin;
